module.exports = __webpack_public_path__ + "static/media/eco-ecology-leaf-svgrepo-com.42f2bc50.svg";